import React from "react";

import styles from "./non-fuel-filter.module.scss";

import { Autocomplete, Field, SearchField, Filter, DateRange, Button } from "components/commons";
import locale from "localization";
import { SelectStationNonFuel } from "components/field";
import { redemptionStatusOptions } from "data/select-options";

const NonFuelFilter = ({
  filterState,
  applyFilter,
  applyClearFilter,
  resetFilter,
  modifyFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
  filterCount,
  exportReport,
  exporting,
}) => {
  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <Filter
          submit={applyFilter}
          close={resetFilter}
          clear={applyClearFilter}
          filterCount={filterCount}
        >
          <Field
            className={styles.date}
            labelPosition={"left"}
            label={locale.transactionDate}
            childrenClassName={styles.fieldContent}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              onChange={(_, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({
                  startDate,
                  endDate,
                });
              }}
            />
          </Field>
          <Field
            className={styles.date}
            label={locale.status}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              capitalize={false}
              name={"status"}
              hasAll
              multiple
              placeholder="Select Status"
              value={filterState.status.value}
              options={redemptionStatusOptions}
              onChange={(name, { value, isSelectedAll }) => {
                modifyFilter({ [name]: { value, isSelectedAll } });
              }}
            />
          </Field>
          <Field
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.redemptionStation}
            className={styles.filterInput}
          >
            <SelectStationNonFuel
              {...filterState?.redemptionStation}
              onChange={(_, { value, label }) => {
                modifyFilter({ redemptionStation: { value, label } });
              }}
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchField
            restrict={false}
            searchWithSymbols
            placeholder={locale.nonFuelTransactionSearchKeys}
            value={searchKey}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
          />
        </Field>
        <Field className={styles.downloadButton}>
          <Button
            startIcon={<span className="icon-download" />}
            exportButton
            onClick={exportReport}
            disabled={exporting}
            loading={exporting}
          >
            {locale.export}
          </Button>
        </Field>
      </div>
    </div>
  );
};

export default NonFuelFilter;
